<div class="row d">
  <div class="col-lg-7">
    <div class="d-md-flex">
      <div class="m-b-10 m-r-20">
        <nz-input-group [nzPrefix]="prefixTemplate" [nzSuffix]="suffixTemplate">
          <input
            type="text"
            nz-input
            placeholder="Search"
            (keyup)="onKeyUp(searchBox.value)"
            [(ngModel)]="searchTerm"
            #searchBox
          />
        </nz-input-group>
        <ng-template #suffixTemplate>
          <a nz-icon class="opacity-05" (click)="resetSearch()">
            <i nz-icon nzType="close" class="opacity-05"></i>
          </a>
        </ng-template>
        <ng-template #prefixTemplate>
          <i nz-icon nzType="search" class="opacity-05"></i>
        </ng-template>
      </div>
    </div>
  </div>
  <div class="col-lg-5">
    <div class="d-md-flex justify-content-end">
      <!-- m-r-20 -->
      <div class="m-b-10">
        <button
              nz-button
              nz-popover
              [nzPopoverContent]="content"
              nz-popover
              nzPopoverTrigger="click"
              nzPopoverPlacement="bottom"
              [(nzPopoverVisible)]="filterVisible"
              (nzPopoverVisibleChange)="onPopoverVisibleChange($event)"
              class="btn-outline resource-btn"
              style="text-align: center"
            >
              All Users<i
                nz-icon
                nzType="caret-down"
                style="position: relative; top: 1px; left: -3px"
                nzTheme="outline"
              ></i>
            </button>
            <ng-template
              class="filter"
              style="text-align: left; padding: 0px !important"
              #content
            >
              <div class="">
                <div nz-row nzGutter="24">
                  <div
                    nz-col
                    class="gutter-row"
                    nzSpan="24"
                    style="padding-bottom: 15px"
                  >
                    <span class="filter-heading">Role</span>
                  </div>
                </div>
              </div>
              <div style="height: 80px" nz-row>
                <div
                  style="color: #2d2d35; font-family: Poppins !important"
                  nz-col
                  nzSpan="24"
                >
                  <label nz-checkbox [(ngModel)]="sales"
                    >Sales Representative</label
                  >
                  <nz-divider
                    style="
                      margin-top: 5px !important;
                      margin-bottom: 10px !important;
                    "
                  ></nz-divider>
                  <label nz-checkbox [(ngModel)]="tech">Tech Representative</label>
                </div>
              </div>
              <div nz-row>
                <div
                  nz-col
                  nzSpan="24"
                  class="d-flex align-items-center justify-content-between"
                >
                  <span class="cancel-label" (click)="cancelFilter()"
                    >Cancel</span
                  >
                  <button
                    class="btn-fill"
                    nz-button
                    nzType="default"
                    nzSize="small"
                    (click)="applyFilters()"
                  >
                    Apply
                  </button>
                </div>
              </div>
            </ng-template>
        <!-- <button
          nz-button
          nz-popover
          nz-popover
          nzPopoverTrigger="click"
          nzPopoverPlacement="bottom"
          class="btn-outline resource-btn"
          style="text-align: center"
        >
          All Users<i
            nz-icon
            nzType="caret-down"
            style="position: relative; top: 1px; left: -3px"
            nzTheme="outline"
          ></i>
        </button> -->
      </div>
      <!-- <button
        nz-button
        nzType="default"
        nz-popover
        nzPopoverPlacement="bottomRight"
        nzPopoverTrigger="click"
        class="btn-fill"
      >
        <span>
          <i class="fa fa-plus button-plus-icon" aria-hidden="true"></i></span
        >&nbsp;NEW
      </button> -->
    </div>
  </div>
</div>

<div class="row" [@wipeOutRight]>
  <div nz-col>
    <div style="max-height: 400px; overflow-y:auto">
      <nz-table
        #usersListTable
        [nzData]="userData"
        [nzPageSize]="20"
        nzSize="small"
      >
        <thead nzSingleSort>
          <tr>
            <th
              nzShowCheckbox
              ngDefaultControl
              class="m-r-15"
              [(nzChecked)]="allChecked"
              (nzCheckedChange)="checkAll($event)"
            ></th>
            <ng-container *ngFor="let column of listOfColumns">
              <th
                *ngIf="column.name !== ''"
                [nzSortOrder]="column.sortOrder"
                [nzSortFn]="column.sortFn"
                [nzSortDirections]="column.sortDirections"
                [nzFilterMultiple]="column.filterMultiple"
                [nzWidth]="column.colWidth"
              >
                {{ column.name }}
              </th>
            </ng-container>
            <!-- <th nzShowSort>Name</th>
            <th nzShowSort>Role</th>
            <th nzShowSort>Phone Number</th> -->
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of usersListTable.data">
            <ng-container>
              <td
                nzShowCheckbox
                ngDefaultControl
                [(nzChecked)]="item.checked"
                (nzCheckedChange)="onCheckboxChange()"
                [ngModelOptions]="{ standalone: true }"
                class="m-r-15"
              ></td>
              <td>{{ item.first_name }}</td>
              <td>{{ item.role_name }}</td>
              <td>{{ item.phone_number}}</td>
            </ng-container>
          </tr>
        </tbody>
      </nz-table>
    </div>
  </div>
</div>
